import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name,
  business_name: payload.business_name,
  phone: payload.phone,
  email: payload.email,
  rfc: payload.rfc,
  address: payload.address
})
var crud = new Crud('Customers', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  customers: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions,
  setModalContactVisible ({ commit }, payload) {
    commit('Contacts/SET_MODAL_VISIBLE', payload, { root: true })
  },
  setModalBranchVisible ({ commit }, payload) {
    commit('Branches/SET_MODAL_VISIBLE', payload, { root: true })
  }
}

const getters = {
  ...crud.getters,
  customers: state => state.customers
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
